import '@wistia/wistia-player';
import { tns } from "tiny-slider";
import GLightbox from 'glightbox';

import { tabs } from "./components/tabs";
import { navigation } from "./components/navigation";
import { navigationMobile } from "./components/navigation-mobile";
import { attachCalendarButtons } from './components/calendar.js';
import { partnersSidebar } from "./components/partners-sidebar";
import { smoothScroll } from "./components/smooth-scroll";
import { searchSidebar } from "./components/search-sidebar";

import { cardsSlider } from "./components/sliders/cards-slider";
import { homepageSlider } from "./components/sliders/homepage-slider";
import { employeesSlider } from "./components/sliders/employees-slider";
import { customerLogosSlider } from "./components/sliders/customer-logos-slider";
import { worldCredentialsSlider } from "./components/sliders/world-credentials-slider";

import { cookieModal } from "./components/modals/cookie-modal";
import { createApp } from 'vue'
import SearchResultsComponent from './components/vue/SearchResultsComponent.vue'
import OpenPositionsComponent from './components/vue/careers/OpenPositionsComponent.vue'
import VacancyFormComponent from './components/vue/careers/VacancyFormComponent.vue'
import JoinNetcrackerComponent from './components/vue/careers/JoinNetcrackerComponent.vue'


const lightbox = GLightbox({
    selector: '.glightbox',
    zoomable: true,
    autofocusCamera: true,
});

const app = createApp({})
app.component('search-results-component', SearchResultsComponent)
app.component('open-positions-component', OpenPositionsComponent)
app.component('vacancy-form-component', VacancyFormComponent)
app.component('join-netcracker-component', JoinNetcrackerComponent)
app.mount('#vue-app')

cookieModal();

document.addEventListener('DOMContentLoaded', () => {
    attachCalendarButtons();
    tabs();
    navigation();
    navigationMobile();
    partnersSidebar();
    searchSidebar();
    smoothScroll();

    cardsSlider();
    homepageSlider();
    employeesSlider();
    customerLogosSlider();
    worldCredentialsSlider();
});

const blocksSliderContainers = document.getElementsByClassName('block-slider');
Array.from(blocksSliderContainers).forEach(container => {
    const slides = container.querySelectorAll('article');
    let slider = tns({
        container: container,
        "responsive": {
            "390": {
                "items": 1
            },
            "800": {
                "items": 2
            },
            "1440": {
                "items": 3
            },
            "1920": {
                "items": 4
            }
        },
        startIndex: 0,
        autoplay: false,
        loop: false,
        "fixedWidth": 280,
        controls: () => {
            container.offsetWidth
        },
        controlsContainer: container.nextElementSibling,
        "swipeAngle": false,
        nav: false,
        "speed": 400
    })
});

